
import {Card, Col, Descriptions, Row, Tag} from 'antd';
import React, {useEffect, useState} from 'react';
import {requestUserInfo} from "../../../../axios/http";
import moment from "moment";

const tabList = [
    {
        key: 'tab1',
        tab: 'tab4',
    },
    {
        key: 'tab2',
        tab: 'tab3',
    },
];


type Props = {
    id: number
};
export const UserChild = (props: Props) => {
    const { id } = props
    const [activeTabKey1, setActiveTabKey1] = useState<string>('tab1');
    const [userInfo, setUserInfo] = useState<any>({active:true});
    const [tabList, setTabList] = useState<any>([]);
    const [contentList, setContentList] = useState<any>([]);
    const onTab1Change = (key: string) => {
        setActiveTabKey1(key);
    };

    async function getUserInfo(){
       let result = await requestUserInfo(id)
        let parm: any = {}
        const arr = result.data.groups.map((item : any)=>{

            return {
                key: item.id,
                tab: item.name,
            }
        })

        result.data.groups.forEach((item : any)=>{
            let {id} = item

            parm[id]= <div className="site-card-wrapper">
                    <Row gutter={16}>
                        {item.devices.map((item:any)=>{
                            return <Col span={8}>
                                <Card title={item.name} bordered={true}>
                                    <div>{`id: ${item.id}`}</div>
                                    <div>{`eui: ${item.eui}`}</div>
                                    <div>{`name: ${item.name}`}</div>
                                    <div>{`description: ${item.description}`}</div>
                                    <div>{`device_type: ${item.device_type}`}</div>
                                    <div>{`create_time: ${item.create_time&&moment(item.create_time).format('YYYY-MM-DD HH:mm:ss')}`}</div>
                                    <div>{`enable: ${item.enable ? 'enable' : 'Not enable'
                                    }`}</div>
                                </Card>
                            </Col>
                        })}
                    </Row>
            </div>

        })
        setContentList(parm)
        setTabList(arr)
        setUserInfo(result.data)

    }

    useEffect(() => {
        getUserInfo()
    }, []);


    return (
        <>
            <Descriptions title="User Info" style={{width: '100%', margin: '50px 0'}}>
                <Descriptions.Item label="id">
                    {userInfo.id}
                </Descriptions.Item>
                <Descriptions.Item label="user_nick">{userInfo.user_nick}</Descriptions.Item>
                <Descriptions.Item label="user_login">{userInfo.user_login}</Descriptions.Item>
                <Descriptions.Item label="email">{userInfo.email}</Descriptions.Item>
                <Descriptions.Item label="active">{userInfo.active ? <Tag color={'green'} key={'active'}>
                    active
                </Tag>:<Tag color={'red'} key={'active'}>
                    Not activated
                </Tag>}</Descriptions.Item>
                <Descriptions.Item label="active_token">
                    {userInfo.active_token}
                </Descriptions.Item>
                <Descriptions.Item label="u_id">
                    {userInfo.u_id}
                </Descriptions.Item>

                <Descriptions.Item label="picture">
                    {userInfo.picture}
                </Descriptions.Item>
                <Descriptions.Item label="create_time"> {userInfo.create_time&&moment(userInfo.create_time).format('YYYY-MM-DD HH:mm:ss')}</Descriptions.Item>
            </Descriptions>

            <Card
                style={{ width: '100%', margin:'50px 0' }}
                title="Group List"
                tabList={tabList}
                activeTabKey={activeTabKey1}
                onTabChange={key => {
                    onTab1Change(key);
                }}
            >
                {contentList[activeTabKey1]}
            </Card>
        </>
    );
};